import { cn } from "@/lib/utils";

/** Status → (token class, default label). Always text + dot, never colour alone. */
const MAP = {
  ny: ["badge-reserved", "Ny"],
  publisert: ["badge-confirmed", "Publisert"],
  utkast: ["badge-muted", "Utkast"],
  godkjend: ["badge-confirmed", "Godkjend"],
  avvist: ["badge-cancelled", "Avvist"],
  public: ["badge-waitlist", "Ope"],
  privat: ["badge-muted", "Privat"],
  private: ["badge-muted", "Privat"],
  fast: ["badge-reserved", "Fast aktivitet"],
  heile: ["badge-muted", "Heile huset"],
  komande: ["badge-confirmed", "Komande"],
  passert: ["badge-expired", "Passert"],
  skjult: ["badge-warning", "Skjult"],
  billettar: ["badge-waitlist", "Billettar"],
  aktiv: ["badge-confirmed", "Aktiv"],
  pause: ["badge-muted", "Pause"],
  inaktiv: ["badge-expired", "Inaktiv"],
  open: ["badge-confirmed", "Open"],
  closed: ["badge-warning", "Mellombels stengt"],
  konflikt: ["badge-warning", "Mogleg kollisjon"],
  mellombels: ["badge-warning", "Mellombels"],
  plasshaldar: ["badge-warning", "Plasshaldar"],
  ulest: ["badge-reserved", "Ulest"],
  lest: ["badge-muted", "Lest"],
  paa: ["badge-confirmed", "På"],
  av: ["badge-muted", "Av"],
  booking: ["badge-waitlist", "Frå booking"],
  arrangement: ["badge-waitlist", "Frå arrangement"],
  husvert: ["badge-waitlist", "Via chatten"],
  reserved: ["badge-reserved", "Reservert"],
  ventar: ["badge-reserved", "Ventar"],
  confirmed: ["badge-confirmed", "Stadfesta"],
  cancelled: ["badge-cancelled", "Avbroten"],
  expired: ["badge-expired", "Utgått"],
  waitlist: ["badge-waitlist", "Venteliste"],
  admin: ["badge-confirmed", "Administrator"],
  bruker: ["badge-muted", "Brukar"],
  deaktivert: ["badge-expired", "Deaktivert"],
};

export const StatusPill = ({ status, label, className, ...props }) => {
  const [cls, text] = MAP[status] || ["badge-muted", status];
  return <span className={cn("badge-status", cls, className)} {...props}>{label || text}</span>;
};
